import MuiButton from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const options = {
  shouldForwardProp: (prop) => prop !== "rounded",
};

const RoundButton = styled(
  MuiButton,
  options,
)(({ theme, rounded }) => ({
  borderRadius: rounded ? "15px" : null,
}));

export default RoundButton;
